<div class="admin-login" *ngIf="true">
  <div nz-row class="login-box" nzType="flex" nzJustify="center">
    <div nz-row nzJustify="center">
      <div class="logo"><img src="./assets/img/admin-logo.png" /></div>
    </div>
    <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
      <div class="app-title">
        <span>{{ "app.label.admin-title" | translate }}</span>
      </div> 
      <nz-divider class="divider-no-margin"></nz-divider>
      <form nz-form [formGroup]="validateForm" nzLayout="vertical">
        <nz-form-item>
          <nz-form-label>{{ "app.label.username" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.username.required' | translate">
            <nz-input-group [nzPrefix]="prefixUser">
              <input type="text" nz-input formControlName="userName"
                placeholder="{{ 'app.label.username' | translate }}" [nzSize]="'large'" autocomplete="off" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label>{{ "app.label.password" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.password.required' | translate">
            <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
              <input [nzSize]="'large'" [type]="passwordVisible ? 'text' : 'password'" nz-input
                placeholder="{{ 'app.label.password' | translate }}" formControlName="password" autocomplete="off" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"></i>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <img [src]="captchaImageUrl" />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <i class="capchaHeight" nz-icon nzType="reload-captcha" nzTheme="outline"
              (click)="getCaptchaImageAndKey()"></i>
          </ng-template>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label>{{ "app.label.captcha" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.captcha.required' | translate">
            <input type="text" nz-input formControlName="captcha" placeholder="{{ 'app.label.captcha' | translate }}"
              autocomplete="off" />
          </nz-form-control>
          <a class="text-right display-block w100" (click)="forgotpassword()">{{
            "app.login.forgotpassword" | translate
            }}</a>
        </nz-form-item>
        <nz-form-item class="mb0">
          <nz-form-control>
            <button nz-button [nzSize]="'large'" [nzType]="'primary'" class="btn-full-left" (click)="goto()"
              [nzLoading]="loading" [disabled]="validateForm.invalid">
              {{ "app.label.signin" | translate }}
            </button>
            <!-- <a class="float-right display-block" (click)="signup()"></a> -->
          </nz-form-control>
        </nz-form-item>
      </form>
      <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
      <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
    </nz-card>
  </div>
</div>
<div class="login-wrapper" *ngIf="false">
  <div class="left-sec">
    <div nz-row class="login-box" nzType="flex" nzJustify="center">
    
    <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
      <div class="app-title">
        <span>{{ "app.label.admin-title" | translate }}</span>
      </div> 
      <nz-divider class="divider-no-margin divider-white"></nz-divider>
      <form nz-form [formGroup]="validateForm" nzLayout="vertical">
        <nz-form-item>
          <nz-form-label class="label-white">{{ "app.label.username" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.username.required' | translate">
            <nz-input-group [nzPrefix]="prefixUser">
              <input type="text" nz-input formControlName="userName"
                placeholder="{{ 'app.label.username' | translate }}" [nzSize]="'large'" autocomplete="off" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="label-white">{{ "app.label.password" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.password.required' | translate">
            <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
              <input [nzSize]="'large'" [type]="passwordVisible ? 'text' : 'password'" nz-input
                placeholder="{{ 'app.label.password' | translate }}" formControlName="password" autocomplete="off" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"></i>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
            <img [src]="captchaImageUrl" />
          </nz-input-group>
          <ng-template #suffixIconButton>
            <i class="capchaHeight icon-white" nz-icon nzType="reload-captcha" nzTheme="outline"
              (click)="getCaptchaImageAndKey()"></i>
          </ng-template>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="label-white">{{ "app.label.captcha" | translate }}</nz-form-label>
          <nz-form-control [nzErrorTip]="'app.login.captcha.required' | translate">
            <input type="text" nz-input formControlName="captcha" placeholder="{{ 'app.label.captcha' | translate }}"
              autocomplete="off" />
          </nz-form-control>
          <a class="text-right display-block w100 link-white" (click)="forgotpassword()">{{
            "app.login.forgotpassword" | translate
            }}</a>
        </nz-form-item>
        <nz-form-item class="mb0">
          <nz-form-control>
            <button nz-button [nzSize]="'large'" [nzType]="'primary'" class="btn-full-left" (click)="goto()"
              [nzLoading]="loading" [disabled]="validateForm.invalid">
              {{ "app.label.signin" | translate }}
            </button>
            <!-- <a class="float-right display-block" (click)="signup()"></a> -->
          </nz-form-control>
        </nz-form-item>
      </form>
      <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
      <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
    </nz-card>
  </div>
  </div>
  <div class="right-sec">
    <div  >
      <div class="logo"><img src="./assets/img/admin-logo.png" /></div>
    </div>
  </div>
</div>